// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__gzTde","breadcrumb__item":"breadcrumb_breadcrumb__item__EkT6_","breadcrumb__item_active":"breadcrumb_breadcrumb__item_active__qLysb"};